import { useEffect, useState } from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/24/outline";
import Candidates from "./Candidates";
import { locales } from "../../locales";
import { getDataSource } from "../../services/api";
import { formatString } from "../../utils/communesUtils";

function CandidatesAccordion({
  data,
  langId,
  isDesktop,
  openCloseAll,
  commune,
  communeType,
  onShowTooltip,
  onHideTooltip,
}) {
  const [open, setOpen] = useState(false);

  const onClickHandler = () => {
    setOpen(!open);
    window.wort.frameResize();
  };

  const isRelativeMajority = communeType === locales[langId].communeTypeSmall;
  const partiesiWithNoLogo = ["Réiden2023"];
  const partyHasLogo = partiesiWithNoLogo.includes(data.party);
  const isFrisangeArequipe =
    (commune === "Frisingen" || commune === "Frisange") &&
    data.party === "Är Equipe" &&
    !isRelativeMajority;

  const isWormeldingenArequipe =
    (commune === "Wormeldingen" || commune === "Wormeldange") &&
    data.party === "Är Equipe" &&
    !isRelativeMajority;

  const isKopstalArequipe =
    commune === "Kopstal" && data.party === "Är Equipe" && !isRelativeMajority;

  const relativeMajorityImage =
    langId === "de"
      ? `${getDataSource()}/parties/relative_majority.svg`
      : `${getDataSource()}/parties/relative_majority_fr.svg`;

  // if party logo is not available, show placeholder image
  function handleImageError(event) {
    const placeholderImageUrl = `https://data-assets.wort.lu/elections/data/parties/${
      langId === "de" ? "kandidate" : "candidate"
    }.svg`;
    event.target.onerror = null; // To prevent infinite loop if the default image is also not available
    event.target.src = placeholderImageUrl;
  }

  useEffect(() => {
    if (openCloseAll) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [openCloseAll]);

  return (
    <div className="py-4">
      <dt className="text-lg">
        <button
          className={`flex w-full items-start justify-between text-left accordion-btn`}
          onClick={onClickHandler}
        >
          <div className="flex flex-row items-center">
            {isFrisangeArequipe && (
              <img
                src={`${getDataSource()}/parties/arequipe_33.svg`}
                alt={data.party}
                width={100}
                onError={handleImageError}
              />
            )}
            {isWormeldingenArequipe && (
              <img
                src={`${getDataSource()}/parties/arequipe.svg`}
                alt={data.party}
                width={53}
                onError={handleImageError}
              />
            )}
            {isKopstalArequipe && (
              <img
                src={relativeMajorityImage}
                alt={communeType}
                width={53}
                onError={handleImageError}
              />
            )}
            {
              // if relative majority, show relative majority logo
              isRelativeMajority && (
                <img
                  src={relativeMajorityImage}
                  alt={communeType}
                  width={38}
                  onError={handleImageError}
                />
              )
            }
            {
              // if no party logo, show relative majority logo
              partyHasLogo && (
                <img
                  src={relativeMajorityImage}
                  alt={communeType}
                  width={38}
                  onError={handleImageError}
                />
              )
            }

            {!isRelativeMajority && data.party === "déi Lénk" && (
              <img
                src={`${getDataSource()}/parties/${data.partyLogo}`}
                alt={data.party}
                width={90}
                onError={handleImageError}
              />
            )}
            {!isRelativeMajority && data.party === "Är Leit" && (
              <img
                src={`${getDataSource()}/parties/${formatString(commune)}_${
                  data.partyLogo
                }`}
                alt={data.party}
                width={53}
                onError={handleImageError}
              />
            )}

            {!isRelativeMajority &&
              data.party !== "déi Lénk" &&
              data.party !== "Är Leit" &&
              data.party !== "Är Equipe" &&
              !partyHasLogo && (
                <img
                  src={`${getDataSource()}/parties/${data.partyLogo}`}
                  alt={data.party}
                  width={53}
                  onError={handleImageError}
                />
              )}
            <span className="ml-3.5 text-2xl">
              {isRelativeMajority ? locales[langId].candidates : data.party}
            </span>
          </div>
          <span className="ml-6 flex h-7 items-center">
            {open ? (
              <MinusIcon
                className="h-6 w-6 hover:text-primary"
                aria-hidden="true"
              />
            ) : (
              <PlusIcon
                className="h-6 w-6 hover:text-primary"
                aria-hidden="true"
              />
            )}
          </span>
        </button>
      </dt>
      {open && (
        <div className="mt-2">
          <Candidates
            data={data.candidates}
            langId={langId}
            isDesktop={isDesktop}
            onShowTooltip={onShowTooltip}
            onHideTooltip={onHideTooltip}
          />
        </div>
      )}
    </div>
  );
}

export default CandidatesAccordion;
